/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { AdSpend, AdSpendInput } from "../models/index";
import {
  AdSpendFromJSON,
  AdSpendToJSON,
  AdSpendInputFromJSON,
  AdSpendInputToJSON,
} from "../models/index";

export interface DeleteAdSpendRequest {
  adSpendId: string;
}

export interface EditAdSpendRequest {
  adSpendInput: AdSpendInput;
}

export interface InsertAdSpendRequest {
  adSpendInput: AdSpendInput;
}

/**
 *
 */
export class AdSpendApi extends runtime.BaseAPI {
  /**
   */
  async deleteAdSpendRaw(
    requestParameters: DeleteAdSpendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["adSpendId"] == null) {
      throw new runtime.RequiredError(
        "adSpendId",
        'Required parameter "adSpendId" was null or undefined when calling deleteAdSpend().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["adSpendId"] != null) {
      queryParameters["adSpendId"] = requestParameters["adSpendId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/ad-spend/delete-ad-spend`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteAdSpend(
    requestParameters: DeleteAdSpendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteAdSpendRaw(requestParameters, initOverrides);
  }

  /**
   */
  async editAdSpendRaw(
    requestParameters: EditAdSpendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["adSpendInput"] == null) {
      throw new runtime.RequiredError(
        "adSpendInput",
        'Required parameter "adSpendInput" was null or undefined when calling editAdSpend().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/ad-spend/edit-ad-spend`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AdSpendInputToJSON(requestParameters["adSpendInput"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async editAdSpend(
    requestParameters: EditAdSpendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.editAdSpendRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getAllAdSpendRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<AdSpend>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/ad-spend/get-all-ad-spend`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AdSpendFromJSON),
    );
  }

  /**
   */
  async getAllAdSpend(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<AdSpend>> {
    const response = await this.getAllAdSpendRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async insertAdSpendRaw(
    requestParameters: InsertAdSpendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters["adSpendInput"] == null) {
      throw new runtime.RequiredError(
        "adSpendInput",
        'Required parameter "adSpendInput" was null or undefined when calling insertAdSpend().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/ad-spend/insert-ad-spend`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AdSpendInputToJSON(requestParameters["adSpendInput"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   */
  async insertAdSpend(
    requestParameters: InsertAdSpendRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.insertAdSpendRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
